var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSalesforceAccessDeniedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19406_37902",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 172,
    height: 172
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86,
    r: 86,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19406_37902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.2 174.899C125.081 174.899 156.6 143.38 156.6 104.499C156.6 65.6183 125.081 34.0991 86.2 34.0991C47.3192 34.0991 15.8 65.6183 15.8 104.499C15.8 143.38 47.3192 174.899 86.2 174.899Z",
    fill: "url(#paint0_linear_19406_37902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.9 111.599C-19.1 111.599 -14.3 115.999 -13.1 121.799C-10.3 114.799 -3.9 109.999 3.5 109.999C9.3 109.999 14.4 112.999 17.7 117.599C20.7 111.299 26.8 107.099 33.7 107.099C40.1 107.099 45.8 110.799 49 116.299C51.1 113.499 54.4 111.699 58 111.699C62.5 111.699 66.4 114.499 68.4 118.599C73.6 110.799 82 105.699 91.5 105.699C100.5 105.699 108.6 110.299 113.8 117.399C116.3 111.999 121.4 108.299 127.4 108.299C133.5 108.299 138.7 112.199 141.2 117.799C143.4 114.899 146.7 113.099 150.5 113.099C155.4 113.099 159.7 116.299 161.6 120.999C163.9 112.899 170.8 107.099 178.9 107.099C186 107.099 192.2 111.599 195.1 118.099C196.5 115.699 199.1 113.999 201.9 113.999C204.3 113.999 206.5 115.199 208 116.999C211.8 108.799 219.6 103.099 228.6 103.099C241.3 103.099 251.6 114.399 251.6 128.199V180.699H-37V124.799C-37 117.599 -31.6 111.599 -24.9 111.599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M86.5 124C81.2421 124 77 128.27 77 133.562C77 147.334 86.5 156.356 86.5 175C86.5 156.356 96 147.334 96 133.562C96 128.33 91.7579 124 86.5 124Z",
    fill: "#E9F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5 124C82.9159 124 80 126.873 80 130.404C80 139.563 86.5 145.609 86.5 158C86.5 145.609 93 139.563 93 130.404C93 126.873 90.0841 124 86.5 124Z",
    fill: "#E4F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1001 129.299L75.2 129.199C74.2 129.199 73.3 128.399 73.3 127.299V123.199L99 123.299V127.399C99 128.399 98.1001 129.299 97.1001 129.299Z",
    fill: "url(#paint1_linear_19406_37902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 86.7993L127.1 106.699C128.8 109.099 129.4 112.099 128.7 114.899L122 141.999C121.8 142.899 120.7 143.199 120 142.599L98.7 122.999L113 86.7993Z",
    fill: "url(#paint2_linear_19406_37902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6001 86.5991L45.3001 106.399C43.6001 108.799 43.0001 111.799 43.7001 114.599L50.2001 141.699C50.4001 142.599 51.5001 142.899 52.2001 142.299L73.7001 122.999L59.6001 86.5991Z",
    fill: "url(#paint3_linear_19406_37902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6002 9.69922C62.3002 29.4992 48.9002 91.9992 68.4002 121.699C69.0002 122.599 69.9002 123.199 70.9002 123.199L101.2 123.399C102.2 123.399 103.1 122.899 103.7 121.899C123.6 92.2992 110.7 29.6992 86.6002 9.69922Z",
    fill: "url(#paint4_linear_19406_37902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6 9.69922C77.8 16.7992 70.5 29.5992 65.6 44.2992C57.8 43.8992 107.3 44.4992 107.3 44.4992C102.5 29.6992 95.3 16.8992 86.6 9.69922Z",
    fill: "url(#paint5_linear_19406_37902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3 83.8994C94.032 83.8994 100.3 77.6314 100.3 69.8994C100.3 62.1674 94.032 55.8994 86.3 55.8994C78.5681 55.8994 72.3 62.1674 72.3 69.8994C72.3 77.6314 78.5681 83.8994 86.3 83.8994Z",
    fill: "url(#paint6_linear_19406_37902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5001 68.1995C98.4001 74.3995 94.2001 80.0995 88.0001 81.0995C81.8001 81.9995 76.1001 77.7995 75.1001 71.5995C74.2001 65.3995 78.4001 59.6995 84.6001 58.6995C90.9001 57.7995 96.6001 61.9995 97.5001 68.1995Z",
    fill: "url(#paint7_linear_19406_37902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5 68.1996C97.1 65.5996 95.8 63.2996 94.1 61.5996C94.1 61.8996 94.1 62.1996 94.2 62.4996C94.4 63.8996 94.7 65.2996 94.3 66.6996C93.9 67.8996 92.9 68.9996 91.7 69.3996C90 69.9996 87.9 69.4996 86.2 70.1996C84.1 71.0996 83.3 73.6996 81.2 74.6996C80.2 75.1996 79.1 75.1996 78.1 74.9996C77.4 74.8996 76.6 74.6996 76 74.1996C78 78.7996 82.9 81.6996 88.1 80.8996C94.2 80.1996 98.5 74.3996 97.5 68.1996Z",
    fill: "url(#paint8_linear_19406_37902)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M86.7002 60.4995C86.5002 60.4995 86.2002 60.4995 86.0002 60.4995C85.7002 60.4995 85.5002 60.5995 85.4002 60.7995C85.2002 60.9995 85.2002 61.1995 85.2002 61.4995C85.2002 61.9995 85.6002 62.3995 86.1002 62.3995H86.2002C86.4002 62.3995 86.6002 62.3995 86.8002 62.3995C87.1002 62.3995 87.3002 62.2995 87.5002 62.0995C87.7002 61.8995 87.8002 61.6995 87.8002 61.3995C87.6002 60.8995 87.2002 60.4995 86.7002 60.4995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M83.5002 61.0994C83.3002 60.9994 83.0002 60.9994 82.8002 61.0994C80.4002 62.0994 78.5002 63.9994 77.5002 66.3994C77.3002 66.8994 77.6002 67.3994 78.0002 67.5994C78.1002 67.5994 78.2002 67.6994 78.3002 67.6994C78.7002 67.6994 79.0002 67.4994 79.2002 67.0994C80.0002 65.0994 81.5002 63.5994 83.4002 62.7994C83.6002 62.6994 83.8002 62.4994 83.9002 62.2994C84.0002 62.0994 84.0002 61.7994 83.9002 61.5994C83.9002 61.3994 83.8002 61.1994 83.5002 61.0994Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.8 116.499C69.5 118.699 70.3 120.999 71.1 123.199H84.4C84.2 122.799 83.9 122.399 83.7 122.099C83.1 121.099 82.6 120.099 82.1 119.099C81 117.099 80.1 114.999 79.1 112.799C77.3 108.499 75.8 104.099 74.6 99.4991C72.2 90.3991 71 80.8991 71 71.2991C71.1 66.4991 71.3 61.6991 72 56.8991L72.2 55.0991L72.5 53.2991L73.1 49.6991L73.9 46.0991L74.3 44.2991L74.8 42.4991C77.2 33.0991 80.8 23.8991 85.1 15.0991C79.8 23.3991 75.3 32.2991 71.8 41.5991L71.1 43.2991L70.5 45.0991L69.3 48.6991L68.3 52.2991L67.8 54.0991L67.4 55.8991C66.2 60.7991 65.4 65.6991 64.8 70.7991C63.6 80.7991 63.9 91.0991 65.4 101.299C66.2 106.399 67.3 111.499 68.8 116.499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0001 149.099C83.8001 149.099 82.1001 147.299 82.0001 145.199L81.6 118.099C81.5 114.799 81.8001 111.399 82.5001 108.099L85.1 94.6992H87.4001L89.9001 108.099C90.5001 111.399 90.8 114.699 90.7 118.099L90.1 145.199C90 147.399 88.2001 149.099 86.0001 149.099Z",
    fill: "url(#paint9_linear_19406_37902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1001 146.799C76.1001 147.099 75.9001 147.299 75.6001 147.299C75.3001 147.299 75.1001 147.099 75.1001 146.799C75.1001 146.499 75.3001 146.299 75.6001 146.299C75.8001 146.299 76.1001 146.499 76.1001 146.799Z",
    fill: "url(#paint10_linear_19406_37902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2 80.8992C108.2 81.2992 107.9 81.5992 107.5 81.5992C107.1 81.5992 106.8 81.2992 106.8 80.8992C106.8 80.4992 107.1 80.1992 107.5 80.1992C107.8 80.1992 108.2 80.4992 108.2 80.8992Z",
    fill: "url(#paint11_linear_19406_37902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7 118.899C89.7 119.199 89.4 119.499 89.1 119.499C88.8 119.499 88.5 119.199 88.5 118.899C88.5 118.599 88.8 118.299 89.1 118.299C89.4 118.299 89.7 118.599 89.7 118.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.5 70.2993C138.5 71.6993 137.4 72.7993 136 72.7993C134.6 72.7993 133.5 71.6993 133.5 70.2993C133.5 68.8993 134.6 67.7993 136 67.7993C137.4 67.7993 138.5 68.8993 138.5 70.2993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7 81.8994C38.7 83.2994 37.6 84.3994 36.2 84.3994C34.8 84.3994 33.7 83.2994 33.7 81.8994C33.7 80.4994 34.8 79.3994 36.2 79.3994C37.5 79.3994 38.7 80.4994 38.7 81.8994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.6 96.2994C148.6 96.7994 148.2 97.1994 147.7 97.1994C147.2 97.1994 146.8 96.7994 146.8 96.2994C146.8 95.7994 147.2 95.3994 147.7 95.3994C148.2 95.3994 148.6 95.7994 148.6 96.2994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1001 139.899C60.1001 140.699 59.4001 141.399 58.6001 141.399C57.8001 141.399 57.1001 140.699 57.1001 139.899C57.1001 139.099 57.8001 138.399 58.6001 138.399C59.5001 138.399 60.1001 139.099 60.1001 139.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6001 121.599C31.6001 122.999 30.5001 124.099 29.1001 124.099C27.7001 124.099 26.6001 122.999 26.6001 121.599C26.6001 120.199 27.7001 119.099 29.1001 119.099C30.5001 119.099 31.6001 120.199 31.6001 121.599Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19406_37902",
    x1: 15.8448,
    y1: 104.466,
    x2: 156.563,
    y2: 104.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.088831,
    stopColor: "#2559CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4104,
    stopColor: "#1D4DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#0F38C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19406_37902",
    x1: 86.1601,
    y1: 129.256,
    x2: 86.1602,
    y2: 123.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5153,
    stopColor: "#C6DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8188,
    stopColor: "#ACD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19406_37902",
    x1: 98.691,
    y1: 114.801,
    x2: 128.999,
    y2: 114.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC7200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4985,
    stopColor: "#FCA22E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD661"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19406_37902",
    x1: 43.3782,
    y1: 114.613,
    x2: 73.6156,
    y2: 114.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5015,
    stopColor: "#FCA22E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19406_37902",
    x1: 53.9766,
    y1: 42.0283,
    x2: 118.847,
    y2: 106.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2088,
    stopColor: "#FBFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6226,
    stopColor: "#DBEBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8275,
    stopColor: "#BFDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_19406_37902",
    x1: 72.4567,
    y1: 23.5493,
    x2: 100.33,
    y2: 51.4229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5015,
    stopColor: "#FCA22E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_19406_37902",
    x1: 76.5152,
    y1: 59.9537,
    x2: 96.1773,
    y2: 79.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0833177,
    stopColor: "#FCC019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4305,
    stopColor: "#FDA729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7462,
    stopColor: "#FD9732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9235"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_19406_37902",
    x1: 78.3427,
    y1: 61.8816,
    x2: 94.3501,
    y2: 77.8901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2559CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3525,
    stopColor: "#2255CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6915,
    stopColor: "#1B4AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F38C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_19406_37902",
    x1: 83.392,
    y1: 66.9308,
    x2: 94.3505,
    y2: 77.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F38C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3481,
    stopColor: "#143FC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8476,
    stopColor: "#2052CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2559CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_19406_37902",
    x1: 71.9385,
    y1: 107.913,
    x2: 100.409,
    y2: 136.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5015,
    stopColor: "#FCA22E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_19406_37902",
    x1: 75.0263,
    y1: 146.833,
    x2: 76.074,
    y2: 146.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBE9F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_19406_37902",
    x1: 106.668,
    y1: 80.9203,
    x2: 108.165,
    y2: 80.9203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBE9F5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesforceAccessDeniedIcon);
export default __webpack_public_path__ + "static/media/SalesforceAccessDeniedIcon.19e620c4.svg";
export { ForwardRef as ReactComponent };